import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLPictureElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLPictureElement
 */
export default class HTMLPictureElement extends HTMLElement {}
